const findExistingFee = ({ existingAdditionalFees, existingZeroPayments, feeTypeId, name }) => {
  const normalizedName = (name || "").trim().toLowerCase();

  const fromAdditionalFees = existingAdditionalFees.find((fee) => {
    const sameType = fee.feeTypeId === feeTypeId;
    const sameName =
      !normalizedName ||
      (fee.name || "").trim().toLowerCase() === normalizedName;
    return sameType && sameName;
  });

  if (fromAdditionalFees) {
    return fromAdditionalFees;
  }

  return existingZeroPayments.find((zp) => zp.feeTypeId === feeTypeId);
};

export const buildAdditionalFeesForSave = ({
  formData,
  accompanyingPersons,
  accompanyingPersonFee,
  selectedFocusedSessions,
  focusedSessions,
  focusedSessionFees,
}) => {
  const additionalFeesArray = [];
  const existingAdditionalFees = formData.additionalFees || [];
  const existingZeroPayments = formData.zeroPayments || [];

  const findExisting = (feeTypeId, name) =>
    findExistingFee({
      existingAdditionalFees,
      existingZeroPayments,
      feeTypeId,
      name,
    });

  console.log("💾 Checking existing items before save:");
  console.log("  - additionalFees:", existingAdditionalFees);
  console.log("  - zeroPayments:", existingZeroPayments);

  console.log("🔍 Checking accompanying persons:");
  console.log("  - accompanyingPersons:", accompanyingPersons);
  console.log("  - accompanyingPersons.length:", accompanyingPersons.length);
  console.log("  - accompanyingPersonFee:", accompanyingPersonFee);

  if (accompanyingPersonFee) {
    console.log("✅ Conditions met - processing accompanying persons");

    accompanyingPersons.forEach((person, index) => {
      console.log(`  - Processing person ${index + 1}:`, person);

      if (person.name && person.name.trim() !== "") {
        const alreadyPaid = person.paid && person.paymentId;
        const existingFee = findExisting(accompanyingPersonFee.id, person.name);

        if (alreadyPaid) {
          console.log(
            "  ⏭️ Skipping PAID person (backend will preserve):",
            person.name
          );
        } else {
          console.log(
            existingFee
              ? "  ♻️ Re-sending existing UNPAID person (keeps row by id):"
              : "  ➕ Adding NEW UNPAID person (will sync to backend):",
            person.name
          );
          additionalFeesArray.push({
            id: existingFee?.id || null,
            feeTypeId: accompanyingPersonFee.id,
            name: person.name,
            rate: parseFloat(accompanyingPersonFee.rate || 0),
            paymentId: existingFee?.paymentId || null,
          });
        }
      } else {
        console.log("  ⚠️ Skipping person with empty name");
      }
    });

    console.log(
      `  📊 Total unpaid persons sent to backend: ${
        additionalFeesArray.filter(
          (fee) => fee.feeTypeId === accompanyingPersonFee.id
        ).length
      }`
    );
  } else {
    console.log("⚠️ accompanyingPersonFee is null or undefined");
  }

  if (selectedFocusedSessions.length > 0) {
    selectedFocusedSessions.forEach((sessionId) => {
      const existingFee = findExisting(sessionId);
      const session = focusedSessions.find((s) => s.id === sessionId);
      const sessionFee = focusedSessionFees[sessionId];

      if (session && sessionFee) {
        console.log(
          existingFee
            ? "  ♻️ Re-sending existing focused session (keeps row by id):"
            : "  ➕ Adding NEW focused session:",
          session.value || session.name,
          "rate:",
          sessionFee.rate
        );
        additionalFeesArray.push({
          id: existingFee?.id || null,
          feeTypeId: sessionId,
          name: session.value || session.name || `Workshop ${sessionId}`,
          rate: parseFloat(sessionFee.rate || 0),
          paymentId: existingFee?.paymentId || null,
        });
      } else {
        console.log(
          "  ⚠️ Skipping focused session because data is incomplete:",
          sessionId
        );
      }
    });
  }

  console.log("🆕 New additional fees to be added:", additionalFeesArray);
  console.log("📋 Existing additional fees:", existingAdditionalFees);
  console.log("🆓 Existing zero payments:", existingZeroPayments);
  console.log("═══════════════════════════════════════════");
  console.log("🎯 FINAL CHECK BEFORE SENDING TO BACKEND:");
  console.log("  - additionalFeesArray.length:", additionalFeesArray.length);
  console.log(
    "  - additionalFeesArray:",
    JSON.stringify(additionalFeesArray, null, 2)
  );
  console.log("═══════════════════════════════════════════");

  return additionalFeesArray;
};
